import React from 'react';
import { IconInfoCircle } from '@tabler/icons-react';

import { CarouselSlideActionIcon } from '~/domains/cms/promo/carousel.contests/enums';

function ActionIcon({ icon }: { icon: string }) {
  switch (icon) {
    case CarouselSlideActionIcon.INFO_CIRCLE: {
      return <IconInfoCircle />;
    }
    default: {
      return null;
    }
  }
}

export default ActionIcon;
